export default {
  prod: {
    url: 'https://workflows.app.message2give.com',
    port: '',
    wfApi: 'https://workflows.app.message2give.com/2022-02-14',
    ybApi: 'https://api.app.message2give.com/2019-01-23',
    dmsApi: 'https://dms.yabbr.io/2022-05-31',
    toApi: 'https://timeout.yabbr.io/2022-07-22',
    scheduleApi: 'https://scheduler.yabbr.io/2022-02-14',
    custodianApi: 'https://custodian.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://app.message2give.com',
  },
  dev: {
    url: 'https://workflows.dev.tedirex.yabbr.io',
    port: '',
    wfApi: 'https://workflows.dev.tedirex.yabbr.io/2022-02-14',
    ybApi: 'https://api.dev.tedirex.yabbr.io/2019-01-23',
    dmsApi: 'https://dms.dev.yabbr.io/2022-05-31',
    toApi: 'https://timeout.dev.yabbr.io/2022-07-22',
    scheduleApi: 'https://scheduler.dev.yabbr.io/2022-02-14',
    custodianApi: 'https://custodian.dev.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://go.dev.tedirex.yabbr.io',
  },
  local: {
    url: 'http://localhost:8084',
    port: '8084',
    wfApi: 'https://workflows.dev.tedirex.yabbr.io/2022-02-14',
    ybApi: 'https://api.dev.tedirex.yabbr.io/2019-01-23',
    dmsApi: 'https://dms.dev.yabbr.io/2022-05-31',
    toApi: 'https://timeout.dev.yabbr.io/2022-07-22',
    scheduleApi: 'https://scheduler.dev.yabbr.io/2022-02-14',
    custodianApi: 'https://custodian.dev.yabbr.io/2022-02-02/',
    yabbrPortal: 'https://go.dev.tedirex.yabbr.io',
  },
};
